module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "columns is-multiline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old_password),
      expression: "old_password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.old_password.$error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('register.field.old_password')
    },
    domProps: {
      "value": (_vm.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.old_password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.old_password.$error && !_vm.$v.old_password.required),
      expression: "$v.old_password.$error &&!$v.old_password.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('validation.required')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.new_password.$error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('register.field.new_password')
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_password.$error && !_vm.$v.new_password.required),
      expression: "$v.new_password.$error &&!$v.new_password.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('validation.required')) + "\n    ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.new_password.$error && !_vm.$v.new_password.minLength),
      expression: "$v.new_password.$error &&!$v.new_password.minLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('validation.min.string', {
    min: 8
  })) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "register-form_actions column is-12"
  }, [_c('button', {
    staticClass: "button is-danger is-fullwidth",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.update')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701cc1ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePasswordForm.vue
// module id = 361
// module chunks = 9